export default __webpack_public_path__ + "static/media/me.51c57945.png";